import React from "react";
import logo from "../../src/images/logoDocLift.png";

const footerSections = [
  {
    title: "Platform",
    links: [
      { label: "Customer Support", href: "/solutions/customer-support" },
      { label: "WhatsApp Automation", href: "/solutions/whatsapp" },
      { label: "Knowledge Base", href: "/solutions/knowledge-base" },
      { label: "Appointments", href: "/solutions/appointments" },
      { label: "Surveillance Add-on", href: "/solutions/surveillance" },
    ],
  },
  {
    title: "Industries",
    links: [
      { label: "Bus Services", href: "/industries/bus-services" },
      { label: "Clinics", href: "/industries/clinics" },
      { label: "Dental Practices", href: "/industries/dental" },
      { label: "Salons", href: "/industries/salons" },
      { label: "Beauty Parlours", href: "/industries/beauty-parlours" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Documentation", href: "/resources/docs" },
      { label: "Case Studies", href: "/resources/case-studies" },
      { label: "Security", href: "/security" },
      { label: "API Reference", href: "/developers/api" },
      { label: "Support Center", href: "/support" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Pricing", href: "/pricing" },
      { label: "Contact", href: "/contact" },
      { label: "Privacy Policy", href: "/privacy/" },
      { label: "Terms of Service", href: "/terms/" },
      { label: "Data Deletion", href: "/data-deletion/" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="border-t border-[#dfe8ef] bg-[#0b2034] text-white">
      <div className="mx-auto max-w-[1180px] px-5 py-12 sm:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1.9fr]">
          <div>
            <a href="/home" className="inline-flex items-center rounded-md bg-white px-3 py-2">
              <img src={logo} alt="DocLift" className="h-8 w-auto" />
            </a>
            <p className="mt-5 max-w-[360px] text-sm leading-7 text-[#c8d7e5]">
              DocLift helps service businesses manage customer support, business knowledge, appointments, and enabled add-on services from one multi-tenant platform.
            </p>
            <div className="mt-6 grid gap-2 text-sm text-[#d9e6f1]">
              <a className="transition hover:text-white" href="mailto:info@doclift.ai">
                info@doclift.ai
              </a>
              <a
                className="transition hover:text-white"
                href="https://orryworx.com/"
                target="_blank"
                rel="noreferrer"
              >
                Product of Orryworx
              </a>
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {footerSections.map((section) => (
              <div key={section.title}>
                <h2 className="text-sm font-bold uppercase tracking-wide text-[#9de2c0]">
                  {section.title}
                </h2>
                <ul className="mt-4 grid gap-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm leading-6 text-[#c8d7e5] transition hover:text-white"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid gap-4 border-t border-white/10 pt-6 text-sm text-[#b7c8d8] md:grid-cols-[1fr_auto] md:items-center">
          <p>Copyright 2026 DocLift. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a href="/privacy/" className="transition hover:text-white">
              Privacy
            </a>
            <a href="/terms/" className="transition hover:text-white">
              Terms
            </a>
            <a href="/data-deletion/" className="transition hover:text-white">
              Data Deletion
            </a>
            <a href="/status" className="transition hover:text-white">
              Status
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
